import { ButtonGroup } from "./ButtonGroup";
import { Range } from "@/types/chart";

type RangeButtonGroupParams = {
  range: Range;
  setRange: (range: Range) => void;
  rangeOptions: Range[];
};

export const RangeButtonGroup = ({
  range,
  setRange,
  rangeOptions,
}: RangeButtonGroupParams) => {
  const currentRange = range.replace("y", "");
  const options = getRangeOptions({ rangeOptions });
  const onClick = (range: string) => {
    setRange(`${range}y` as Range);
  };

  return (
    <ButtonGroup
      options={options}
      activeId={currentRange}
      onButtonClick={onClick}
    />
  );
};

const getRangeOptions = ({ rangeOptions }: { rangeOptions?: Range[] }) => {
  const rangeOptionsMap = {
    "3y": { id: "3", name: "3Y" },
    "5y": { id: "5", name: "5Y" },
    "10y": { id: "10", name: "10Y" },
    "15y": { id: "15", name: "15Y" },
  };

  if (!rangeOptions) {
    return Object.values(rangeOptionsMap);
  }

  return rangeOptions.map((range) => rangeOptionsMap[range]);
};
